<template>
  <el-tooltip placement="top" :content="content" :disabled="disabled" popper-class="qm-refresh">
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <template v-else>
      <i
        :style="{ fontSize: `${size}px` }"
        :class="{
          'qm-refresh__icon': true,
          'qm-icon-refresh': true,
          'is-refreshing': $value,
        }"
        @click="emitClick"
      />
    </template>
  </el-tooltip>
</template>

<script>
export default {
  name: 'QmRefresh',
  props: {
    value: {
      type: Boolean,
    },
    content: {
      type: String,
      default: '点击刷新',
    },
    size: {
      type: Number,
      default: 16,
    },
  },
  computed: {
    $value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },

    disabled() {
      return Boolean(this.$slots.default || this.$value)
    },
  },

  methods: {
    emitClick() {
      if (this.$value) return

      this.$value = true

      this.$emit('click', this.$value)
    },
  },
}
</script>
